module.exports = __webpack_public_path__ + "img/tab_luntan.ee64ada3.png";